/* ============================================================
   LIVEZOOK SHOPIFY THEME — theme.js
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  /* ── Mobile Menu Toggle ── */
  const mobileBtn = document.getElementById('mobile-menu-btn');
  const mobileMenu = document.getElementById('mobile-menu');

  if (mobileBtn && mobileMenu) {
    mobileBtn.addEventListener('click', function () {
      const isOpen = !mobileMenu.classList.contains('hidden');
      mobileMenu.classList.toggle('hidden');
      mobileBtn.querySelector('.icon-menu').classList.toggle('hidden', !isOpen);
      mobileBtn.querySelector('.icon-close').classList.toggle('hidden', isOpen);
    });
  }

  /* ── Add to Cart (Ajax) ── */
  document.querySelectorAll('.add-to-cart-btn').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      const form = btn.closest('form');
      if (!form) return;
      e.preventDefault();

      const variantId = form.querySelector('[name="id"]')?.value;
      const quantity = form.querySelector('[name="quantity"]')?.value || 1;
      if (!variantId) return;

      btn.textContent = 'Adding…';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: parseInt(quantity) })
      })
        .then(res => res.json())
        .then(function () {
          btn.textContent = 'Added!';
          updateCartCount();
          setTimeout(function () {
            btn.textContent = 'Add to Bag';
            btn.disabled = false;
          }, 1800);
        })
        .catch(function () {
          btn.textContent = 'Error';
          btn.disabled = false;
        });
    });
  });

  /* ── Cart Count Update ── */
  function updateCartCount() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(function (cart) {
        const counter = document.getElementById('cart-count');
        if (counter) {
          counter.textContent = cart.item_count;
          counter.style.display = cart.item_count > 0 ? 'flex' : 'none';
        }
      });
  }

  updateCartCount();

  /* ── Scroll-triggered fade-up ── */
  if ('IntersectionObserver' in window) {
    const fadeEls = document.querySelectorAll(
      '.category-card, .editorial-card, .product-card, .trust-item, .banner-card'
    );
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );

    fadeEls.forEach(function (el, i) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = 'opacity 0.6s ease ' + i * 0.05 + 's, transform 0.6s ease ' + i * 0.05 + 's';
      observer.observe(el);
    });
  }

  /* ── Header: hide/show on scroll ── */
  var lastScrollY = window.scrollY;
  var header = document.getElementById('site-header');
  window.addEventListener('scroll', function () {
    if (!header) return;
    var currentScrollY = window.scrollY;
    if (currentScrollY > lastScrollY && currentScrollY > 120) {
      header.style.transform = 'translateY(-100%)';
      header.style.transition = 'transform 0.3s ease';
    } else {
      header.style.transform = 'translateY(0)';
    }
    lastScrollY = currentScrollY;
  });

});
